import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export const getAssessments = (params: any) => api.get(url.GET_ASSESSMENTS, params);

export const getAssessment = (id: any, params: any) => {
  const populate = [
    "assessmentType",
    "contractor",
    "agency",
    "reportFile",
    "createdby",
    "createdby.agency",
    "updatedby",
    "capacityAssessmentType",
    "overallRating",
    "overallRiskRating",
    "programmeRisk",
    "diversionRisk",
    "fiduciaryRisk",
    "integrityRisk",
    "fraudRisk",
    "reputationRisk",
    "humanRightsRisk",
    "terrorismRisk",
    "corruptionRisk",
    "obstructionRisk",
    "theftRisk",
    "partnerManagementRisk",
    "communityRelationsRisk",
    "conductedByUser",
    "conductedByContractor",
  ];

  if (!params?.populate) params.populate = populate;
  return api.get(`${url.GET_ASSESSMENT}/${id}`, params);
};

export const addAssessment = (data: any) =>
  api.createAndUpload(url.ADD_ASSESSMENT, data);

export const updateAssessment = (data: any) =>
  api.updateAndUpload(`${url.UPDATE_ASSESSMENT}/${data.id}`, data.formData);

export const deleteAssessment = (data: any) =>
  api.delete(`${url.DELETE_ASSESSMENT}/${data.id}`, data);

export const getAssessmentTypes = (params: any) =>
  api.get(url.GET_ASSESSMENT_TYPES, params);

export const getAssessmentType = (id: any, params: any) =>
  api.get(`${url.GET_ASSESSMENT_TYPE}/${id}`, params);

export const importAssessments = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_ASSESSMENTS, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;

      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (error) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
